import { OrderMarketTypeEnum } from '@toro/common/shared/enum/orders/market-type.enum';
import { LabelSearchEnum } from '@toro/common/shared/enum/label-search.enum';
import { DisposableSafelly } from '@toro/common/shared/components/disposable-safelly/disposable-safelly.component';
import { Component, OnInit, EventEmitter, Output, Input, ViewChild, HostListener, ElementRef, Renderer2, OnDestroy, AfterViewInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { Store } from '@ngrx/store';
import { StocksExploreMarketAction } from '../../state-management/stock-explore-market/stock-explore-market.action';
import { ActivatedRoute } from '@angular/router';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Instrument } from '@toro/common/shared/models/quote/instrument.model';
import { SecurityCategory } from '@toro/common/shared/enum/security-category.enum';
import { fromEvent, Observer, Subject } from 'rxjs';
import { ISearchCachedItem } from '../../interfaces/search-cached--item.interface';
import {TrackingActions} from '@toro/common/shared/state-management/tracking/tracking.action';
import { debounceTime, filter, map, tap } from 'rxjs/operators';

@AutoUnsubscribe()
@Component({
  selector: "hub-search",
  templateUrl: "./hub-search.component.html",
  styleUrls: ["./hub-search.component.scss"],
})
export class HubSearchComponent
  extends DisposableSafelly
  implements OnDestroy, AfterViewInit
{
  public DEBOUNCE_TIME: number = 500;

  public asyncSelected: string;
  public typeaheadLoading: boolean;
  public typeaheadNoResults: boolean;
  public dataSource: Subject<any>;
  public resultsCount: number;
  public onlyCompany: boolean = true;
  public isOption: boolean = false;
  public chipMobile: number;
  public valueSearch: string = "";
  public statesComplex: any[];
  public lastSearch: string;

  @ViewChild("filterContent", { static: false }) public filter: ElementRef;
  @ViewChild("typeAhead", { static: false }) public typeAhead: ElementRef;

  public chips;
  @Input() public label: any;

  @Input() public inputContainerCols = "col-xs-24 col-md-6 col-lg-4";
  @Input() public chipContainerCols = "col-xs-24 col-md-18 col-lg-19";
  @Input() public hideSearch: boolean = false;
  @Input() public hiddenFilter: boolean = false;

  @Output() public emmiter: EventEmitter<number> = new EventEmitter();
  @Output() public search: EventEmitter<any> = new EventEmitter();

  public cachedArray: ISearchCachedItem[] = [];
  private valueArray: any = [];
  private apiSearch: string;
  private isSearchingOption: boolean;
  private isCachedResult: boolean;
  private useCache: boolean = false;

  private searchStock: any;

  @Input() public set setChips(chips) {
    if (chips) {
      this.chips = chips;
      this.search.emit({
        type: "filter",
        value: chips.selected,
        first: true,
      });
    }
  }

  constructor(
    private renderer: Renderer2,
    private AR: ActivatedRoute,
    private store: Store<AppState>
  ) {
    super();

    this.isSearchingOption = false;
    this.dataSource = new Subject();

    this.disposableSubscriptions.push(
      (this.searchStock = this.store.select((state) => state.exploreMarket.searchStocks).pipe(
        filter((data) => {
          return !!data && this.apiSearch === this.lastSearch;
        })
      ).subscribe((data) => {
        this.valueArray = data;
        this.filterStocks(data);
        
        // Create a new, mutable copy of the array before sorting it
        const sortedData = [...data].sort();
        this.dataSource.next(sortedData);
      }))
    );
  }

  public ngAfterViewInit() {
    this.getUrlParams();
    this.disposableSubscriptions.push(
      fromEvent(this.typeAhead.nativeElement, "keyup").pipe(
          map((event: KeyboardEvent) => event.keyCode),
          filter((key: number) => (key === 27 ? this.clearSearch() : true)),
          debounceTime(this.DEBOUNCE_TIME),
          tap(() => this.clearSearchState())
      ).subscribe((data: number) => {
          if (this.asyncSelected.length > 2) {
              this.dispatcher();
          }
      }));
  }

  // get url params for search
  public getUrlParams() {
    this.disposableSubscriptions.push(
      this.AR.queryParams.subscribe((data) => {
        if (data.acao) {
          this.applyFilterDirect(data.acao);
        } else if (data.filtro) {
          this.applyFilter(data.filtro, false);
        }
      })
    );
  }

  public filterStocks(result: any[]) {
    this.resultsCount = result.length;
    this.onlyCompany = result.every(
      (item, index, array) =>
        item.descriptionStock === array[0].descriptionStock
    );
  }

  public changeTypeaheadLoading(e: boolean): void {
    if (
      this.typeAhead.nativeElement.value !== this.lastSearch ||
      this.typeaheadLoading
    ) {
      this.typeaheadLoading = e;
      const element: Element = document.querySelector(".dropdown.open");
      if (element) {
        if (this.typeaheadLoading) {
          element.classList.add("hide");
        } else {
          element.classList.remove("hide");
        }
      }
    }
  }

  public changeTypeaheadNoResults(e: boolean): void {
    if (e) {
      const quoteNotFound = {
        type: "Asset Not Found Searched",
        events: {
          element: this.lastSearch,
          origin: "Pesquisa Bolsa",
        },
      };
      this.store.dispatch({
        type: TrackingActions.trackEvents,
        payload: quoteNotFound,
      });
    }
    this.typeaheadNoResults = e;
  }

  public typeaheadOnSelect(e: TypeaheadMatch): void {
    $("html, body").animate(
      { scrollTop: $(".stock-filter-bar").offset().top },
      500
    );
    this.valueSearch = e.value;

    this.typeAhead.nativeElement.blur();
    const instrument: Instrument = e.item;
    if (!this.isCachedResult) {
      this.updateCacheArray(e.item);
    }
    this.search.emit({
      type: "search",
      value: this.isCachedResult ? e.item : instrument.toInstrumentLite(),
      first: false,
      isCached: this.isCachedResult,
    });
    this.valueArray = null;
  }

  public applyFilterDirect(value: string) {
    this.renderer.addClass(this.filter.nativeElement, "selected");
    this.renderer.addClass(this.filter.nativeElement, "opened");
    this.valueSearch = value;
    this.search.emit({
      type: "search",
      value,
      first: true,
    });
    this.asyncSelected = value.toUpperCase();
    this.dispatcher();
  }

  public applyFilter(chip, fromChip: boolean = true) {
    const selectedChip = this.chips.items.find(
      (item) =>
        item.id === (fromChip ? chip.value.id : chip) ||
        item.value === (fromChip ? chip.value.value : chip)
    );
    this.chips.selected = selectedChip.id;
    this.search.emit({
      type: "filter",
      first: false,
      value: fromChip ? chip.value.value : chip,
    });
  }

  public handleClick(event) {
    let clickedComponent = event.target;
    let inside = false;
    do {
      if (clickedComponent === this.filter.nativeElement) {
        inside = true;
      }
      clickedComponent = clickedComponent.parentNode;
    } while (clickedComponent);
    if (!inside) this.clearSearch();
  }

  public openFilter(event: any) {
    event.stopPropagation();
    event.preventDefault();
    $("html, body").animate(
      { scrollTop: $(".stock-filter-bar").offset().top },
      500
    );
    this.renderer.addClass(this.filter.nativeElement, "opened");
    this.renderer.removeClass(this.filter.nativeElement, "selected");
    $(".search-input").focus();
  }

  public closeFilter(event: any) {
    event.stopPropagation();
    event.preventDefault();
    this.clearSearch();
  }

  public applyFilterMobile(chip) {
    this.chips.selected = chip.id;
    this.emmiter.emit(chip);
    this.search.emit({
      type: "filter",
      first: false,
      value: chip.value,
    });
  }

  public clearSearch() {
    this.typeAhead.nativeElement.blur();
    this.clearSearchState();
    this.search.emit({
      type: "close",
      first: false,
    });

    $(".search-input").val(null);

    this.typeaheadLoading = false;
    this.typeaheadNoResults = false;
    this.valueSearch = null;
    this.asyncSelected = "";
    this.renderer.removeClass(this.filter.nativeElement, "opened");
    this.renderer.removeClass(this.filter.nativeElement, "selected");
    return false;
  }

  public clearSearchState() {
    this.valueArray = null;
    this.store.dispatch({ type: StocksExploreMarketAction.cleanSearchStock });
  }

  public stopPropagation($event) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  /**
   * Return Label for item of search
   * @param typeMarket type market of stock
   * @param securityCategory security category of stock
   */
  public showLabel(
    typeMarket: OrderMarketTypeEnum,
    securityCategory: SecurityCategory
  ) {
    if (securityCategory === SecurityCategory.StocksFuture) {
      return LabelSearchEnum.FutureStock;
    }
    switch (typeMarket) {
      case OrderMarketTypeEnum.Future:
        return LabelSearchEnum.Future;
      case OrderMarketTypeEnum.Option:
        return LabelSearchEnum.Option;
      default:
        return LabelSearchEnum.Stock;
    }
  }

  /**
   * Função pra disparar busca.
   * @param searchOpt Se busca ou não opção.
   */
  public dispatcher() {
    if (
      (this.typeAhead && this.typeAhead.nativeElement.value) ||
      this.typeaheadLoading
    ) {
      if (!this.asyncSelected || this.asyncSelected.trim() === "") return;
      if (this.cachedArray.length > 0 && this.useCache) {
        const trimmed = this.asyncSelected.trim().toUpperCase();
        this.valueArray = this.cachedArray.filter((quote) => {
          return (
            quote.code.indexOf(trimmed) !== -1 ||
            quote.descriptionStock.toUpperCase().indexOf(trimmed) !== -1
          );
        });
        if (this.valueArray.length > 0) {
          this.filterWithResultFromCache();
        } else {
          this.fullSearch();
        }
      } else {
        this.fullSearch();
      }
    }
  }

  /**
   * Função para realizar filtro com resultado da lista em cache
   */
  public filterWithResultFromCache(): void {
    this.filterStocks(this.valueArray);
    this.dataSource.next(this.valueArray.sort());
    this.lastSearch = this.asyncSelected;
    this.isCachedResult = true;
  }

  /**
   * Função para realizar busca na api com os dados utilizados pelo usuário.
   */
  public fullSearch(): void {
    this.store.dispatch({
      type: StocksExploreMarketAction.searchStock,
      payload: {
        code: this.asyncSelected.trim().toUpperCase(),
      },
    });
    this.lastSearch = this.apiSearch = this.asyncSelected;
  }

  public ngOnDestroy() {
    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
  }

  private updateCacheArray(instrument) {
    this.cachedArray.push({
      code: instrument.code,
      descriptionStock: instrument.descriptionStock,
      typeMarket:
        instrument.typeMarket === OrderMarketTypeEnum.Future
          ? "Futuro"
          : "Ação",
    });
  }
}
